/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AmbulanzType } from './AmbulanzType';
import {
    AmbulanzTypeFromJSON,
    AmbulanzTypeFromJSONTyped,
    AmbulanzTypeToJSON,
    AmbulanzTypeToJSONTyped,
} from './AmbulanzType';

/**
 * 
 * @export
 * @interface UpdateAmbulanzRequest
 */
export interface UpdateAmbulanzRequest {
    /**
     * 
     * @type {AmbulanzType}
     * @memberof UpdateAmbulanzRequest
     */
    type: AmbulanzType;
    /**
     * 
     * @type {string}
     * @memberof UpdateAmbulanzRequest
     */
    ambulanzNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAmbulanzRequest
     */
    phone: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAmbulanzRequest
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAmbulanzRequest
     */
    note: string | null;
}



/**
 * Check if a given object implements the UpdateAmbulanzRequest interface.
 */
export function instanceOfUpdateAmbulanzRequest(value: object): value is UpdateAmbulanzRequest {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('ambulanzNumber' in value) || value['ambulanzNumber'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    return true;
}

export function UpdateAmbulanzRequestFromJSON(json: any): UpdateAmbulanzRequest {
    return UpdateAmbulanzRequestFromJSONTyped(json, false);
}

export function UpdateAmbulanzRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAmbulanzRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'type': AmbulanzTypeFromJSON(json['type']),
        'ambulanzNumber': json['ambulanzNumber'],
        'phone': json['phone'],
        'email': json['email'],
        'note': json['note'],
    };
}

export function UpdateAmbulanzRequestToJSON(json: any): UpdateAmbulanzRequest {
    return UpdateAmbulanzRequestToJSONTyped(json, false);
}

export function UpdateAmbulanzRequestToJSONTyped(value?: UpdateAmbulanzRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': AmbulanzTypeToJSON(value['type']),
        'ambulanzNumber': value['ambulanzNumber'],
        'phone': value['phone'],
        'email': value['email'],
        'note': value['note'],
    };
}

